<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <h4>联系方式</h4>
          <ul>
            <!-- <li>电话：{{ contact.phone }}</li> -->
            <li>手机：{{ contact.mobile }}</li>
            <li>地址：{{ contact.address }}</li>
          </ul>
        </div>

        <div class="footer-section">
          <h4>快速链接</h4>
          <ul>
            <li><router-link to="/about">关于我们</router-link></li>
            <li><router-link to="/products">数字乐园</router-link></li>
            <li><router-link to="/solutions">探索方式</router-link></li>
            <li><router-link to="/contact">联系我们</router-link></li>
          </ul>
        </div>
        
        <div class="footer-section">
          <h4>关注我们</h4>
          <ul>
            <li style="display:flex;flex-direction:row;">微信公众号：<img src="@/assets/img/wxgzh.jpg" width="150px" height="150px"/></li>
            <!-- <li>邮箱：{{ contact.email }}</li> -->
          </ul>
        </div>
      </div>
      
      <div class="footer-bottom">
        <p>&copy; {{ currentYear }} {{ footer.copyright }} 版权所有</p>
        <p><a href="https://beian.miit.gov.cn" target="_blank" class="icp">{{ footer.icp }}</a></p>
      </div>
      
      <div class="config-trigger" @click="handleConfigClick"></div>
    </div>
  </footer>
</template>

<script>
import configManager from '@/utils/configManager'
export default {
  name: 'Footer',
  props: {
    footer: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      contact: {
        phone: '',
        mobile: '',
        address: '',
        hours: '',
        wechat: '',
        email: ''
      },
      clickCount: 0,
      clickTimer: null,
      config: {},
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  },
  created() {
    this.loadContact()
    this.loadConfig()
  },
  methods: {
    loadConfig() {
      this.config = configManager.loadConfig()
      this.contact = this.config.contact || {}
    },
    loadContact() {
      const stored = localStorage.getItem('qihuanmath_config')
      if (stored) {
        try {
          const config = JSON.parse(stored)
          this.contact = config.contact || {}
        } catch (e) {}
      }
    },
    handleConfigClick() {
      this.clickCount++
      if (this.clickTimer) {
        clearTimeout(this.clickTimer)
      }
      if (this.clickCount >= 3) {
        this.$emit('openConfig')
        this.clickCount = 0
      } else {
        this.clickTimer = setTimeout(() => {
          this.clickCount = 0
        }, 1000)
      }
    }
  }
}
</script>

<style scoped>
.footer {
  background: #2c3e50;
  color: #fff;
  padding: 50px 0 0;
  margin-top: auto;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-section h4 {
  font-size: 18px;
  margin-bottom: 20px;
  color: #fff;
}

.footer-section ul {
  list-style: none;
}

.footer-section ul li {
  margin-bottom: 12px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}

.footer-section ul li a {
  color: rgba(255, 255, 255, 0.7);
  transition: color 0.3s;
}

.footer-section ul li a:hover {
  color: #667eea;
}

.footer-bottom {
  padding: 25px 0;
  text-align: center;
}

.footer-bottom p {
  margin: 5px 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}

.footer-bottom .icp {
  font-size: 12px;
}

.footer-bottom .icp:hover {
  color: #1366ec;
}

.config-trigger {
  position: fixed;
  bottom: 8px;
  right: 8px;
  width: 8px;
  height: 8px;
  background: #999;
  border-radius: 50%;
  opacity: 0.3;
  cursor: pointer;
  transition: opacity 0.3s;
  z-index: 100;
}

.config-trigger:hover {
  opacity: 0.6;
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 30px;
    text-align: center;
  }
  
  .footer-section h4 {
    font-size: 16px;
  }
  
  .footer {
    padding: 40px 0 0;
  }
}
</style>
